import { getCategoryIcon } from './categoryColors';

// Service logo mapping - popular services with their logos
const SERVICE_LOGOS: { [key: string]: string } = {
  // Entertainment
  'netflix': '/logos/netflix.png',
  'nf': '/logos/netflix.png',
  'youtube': '/logos/youtube.png',
  'yt': '/logos/youtube.png',
  'spotify': '/logos/spotify.png',
  'sp': '/logos/spotify.png',
  'joox': '/logos/joox.png',
  'disney': '/logos/disney.png',
  'disney+': '/logos/disney-hotstar.png',
  'disney+ hotstar': '/logos/disney-hotstar.png',
  'd+': '/logos/disney-hotstar.png',
  'hulu': '/logos/hulu.png',
  'amazon prime video': '/logos/prime-video.png',
  'prime video': '/logos/prime-video.png',
  'prime': '/logos/prime-video.png',
  'hbo': '/logos/hbo-max.png',
  'hbo max': '/logos/hbo-max.png',
  'max': '/logos/max.png',
  'vidio': '/logos/vidio.png',
  'viu': '/logos/viu.png',
  'wetv': '/logos/wetv.png',
  'iqiyi': '/logos/iqiyi.png',
  'paramount': '/logos/paramount.png',
  'paramount+': '/logos/paramount.png',
  'peacock': '/logos/peacock.png',
  'crunchyroll': '/logos/crunchyroll.png',
  'funimation': '/logos/funimation.png',
  'bstation': '/logos/bstation.png',
  'b-station': '/logos/bstation.png',

  // Gaming
  'xbox': '/logos/xbox.png',
  'playstation': '/logos/playstation.png',
  'psn': '/logos/playstation.png',
  'steam': '/logos/steam.png',
  'nintendo': '/logos/nintendo.png',
  'nintendo online': '/logos/nintendo.png',
  'epic games': '/logos/epic-games.png',
  'ubisoft': '/logos/ubisoft.png',
  'ea': '/logos/ea.png',
  'electronic arts': '/logos/ea.png',
  'blizzard': '/logos/blizzard.png',
  'riot games': '/logos/riot-games.png',
  'twitch': '/logos/twitch.png',
  'discord': '/logos/discord.png',

  // Software
  'adobe': '/logos/adobe.png',
  'microsoft': '/logos/microsoft.png',
  'windows': '/logos/windows.png',
  'github': '/logos/github.png',
  'gitlab': '/logos/gitlab.png',
  'canva': '/logos/canva.png',
  'capcut': '/logos/capcut.png',
  'jetbrains': '/logos/jetbrains.png',
  'cursor': '/logos/cursor.png',
  'figma': '/logos/figma.png',
  'framer': '/logos/framer.png',
  'sketch': '/logos/sketch.png',
  'autodesk': '/logos/autodesk.png',
  'unity': '/logos/unity.png',
  'unreal': '/logos/unreal.png',
  'unreal engine': '/logos/unreal.png',
  'lightroom': '/logos/lightroom.png',
  'envato': '/logos/envato.png',
  'dazzcam': '/logos/dazzcam.png',
  'dazzcam pro': '/logos/dazzcam.png',
  'dazz': '/logos/dazzcam.png',

  // Web Services
  'godaddy': '/logos/godaddy.png',
  'go daddy': '/logos/godaddy.png',

  // AI Services
  'chatgpt': '/logos/chatgpt.png',
  'midjourney': '/logos/midjourney.png',
  'gemini': '/logos/gemini.png',
  'claude': '/logos/claude.png',
  'perplexity': '/logos/perplexity.png',

  // Productivity
  'slack': '/logos/slack.png',
  'zoom': '/logos/zoom.png',
  'notion': '/logos/notion.png',
  'trello': '/logos/trello.png',
  'asana': '/logos/asana.png',
  'monday': '/logos/monday.png',
  'monday.com': '/logos/monday.png',
  'clickup': '/logos/clickup.png',
  'airtable': '/logos/airtable.png',
  'microsoft 365': '/logos/microsoft.png',
  'office 365': '/logos/microsoft.png',
  'google workspace': '/logos/google-workspace.png',
  'g suite': '/logos/google-workspace.png',
  'gworkspace': '/logos/google-workspace.png',
  'google drive': '/logos/google-drive.png',
  'gdrive': '/logos/google-drive.png',
  'g drive': '/logos/google-drive.png',
  'g-drive': '/logos/google-drive.png',
  'dropbox': '/logos/dropbox.png',
  'box': '/logos/box.png',
  'evernote': '/logos/evernote.png',
  'roam research': '/logos/roam.png',
  'obsidian': '/logos/obsidian.png',
  'picsart': '/logos/picsart.png',
  'freepik': '/logos/freepik.png',
  'hubspot': '/logos/hubspot.png',
  'grammarly': '/logos/grammarly.png',

  // Social
  'linkedin': '/logos/linkedin.png',
  'twitter': '/logos/twitter.png',
  'instagram': '/logos/instagram.png',
  'facebook': '/logos/facebook.png',
  'tiktok': '/logos/tiktok.png',
  'snapchat': '/logos/snapchat.png',
  'pinterest': '/logos/pinterest.png',
  'reddit': '/logos/reddit.png',
  'telegram': '/logos/telegram.png',
  'whatsapp': '/logos/whatsapp.png',
  'vsco': '/logos/vsco.png',

  // Health
  'fitbit': '/logos/fitbit.png',
  'myfitnesspal': '/logos/myfitnesspal.png',
  'noom': '/logos/noom.png',
  'weight watchers': '/logos/weight-watchers.png',
  'ww': '/logos/weight-watchers.png',
  'calm': '/logos/calm.png',
  'headspace': '/logos/headspace.png',
  'betterhelp': '/logos/betterhelp.png',
  'talkspace': '/logos/talkspace.png',
  'apple fitness': '/logos/apple-fitness.png',
  'apple fitness+': '/logos/apple-fitness.png',
  'peloton': '/logos/peloton.png',

  // Education
  'coursera': '/logos/coursera.png',
  'udemy': '/logos/udemy.png',
  'skillshare': '/logos/skillshare.png',
  'masterclass': '/logos/masterclass.png',
  'duolingo': '/logos/duolingo.png',
  'babbel': '/logos/babbel.png',
  'rosetta stone': '/logos/rosetta-stone.png',
  'khan academy': '/logos/khan-academy.png',
  'brilliant': '/logos/brilliant.png',
  'pluralsight': '/logos/pluralsight.png',
  'dicoding': '/logos/dicoding.png',
  'ruangguru': '/logos/ruang-guru.png',

  // Finance
  'mint': '/logos/mint.png',
  'ynab': '/logos/ynab.png',
  'you need a budget': '/logos/ynab.png',
  'quicken': '/logos/quicken.png',
  'turbotax': '/logos/turbotax.png',
  'h&r block': '/logos/hr-block.png',
  'hr block': '/logos/hr-block.png',
  'credit karma': '/logos/credit-karma.png',
  'robinhood': '/logos/robinhood.png',
  'coinbase': '/logos/coinbase.png',
  'paypal': '/logos/paypal.png',
  'stripe': '/logos/stripe.png',

  // Shopping
  'amazon': '/logos/amazon.png',
  'costco': '/logos/costco.png',
  'walmart': '/logos/walmart.png',
  'target': '/logos/target.png',
  'best buy': '/logos/best-buy.png',
  'home depot': '/logos/home-depot.png',
  'lowes': '/logos/lowes.png',
  'ikea': '/logos/ikea.png',
  'wayfair': '/logos/wayfair.png',
  'etsy': '/logos/etsy.png',
  'ebay': '/logos/ebay.png',

  // Food
  'doordash': '/logos/doordash.png',
  'uber eats': '/logos/uber-eats.png',
  'grubhub': '/logos/grubhub.png',
  'postmates': '/logos/postmates.png',
  'instacart': '/logos/instacart.png',
  'blue apron': '/logos/blue-apron.png',
  'hello fresh': '/logos/hello-fresh.png',
  'hellofresh': '/logos/hello-fresh.png',
  'meal kit': '/logos/meal-kit.png',
  'starbucks': '/logos/starbucks.png',
  'dunkin': '/logos/dunkin.png',
  'grab': '/logos/grab.png',
  'grabfood': '/logos/grabfood.png',
  'grab food': '/logos/grabfood.png',
  'grabfood+': '/logos/grabfood.png',
  'gojek': '/logos/gojek.png',
  'gofood': '/logos/gojek.png',

  // Home
  'nest': '/logos/nest.png',
  'ring': '/logos/ring.png',
  'philips hue': '/logos/philips-hue.png',
  'smartthings': '/logos/smartthings.png',
  'alexa': '/logos/alexa.png',
  'google home': '/logos/google-home.png',
  'homekit': '/logos/homekit.png',
  'wemo': '/logos/wemo.png',
  'tp-link': '/logos/tp-link.png',
  'kasa': '/logos/kasa.png',
};

// Normalize service name for matching
const normalizeServiceName = (name: string): string => {
  return name.toLowerCase().trim();
};

// Get service logo or fallback to category icon
export const getServiceLogo = (serviceName: string, category: string): string => {
  const normalizedName = normalizeServiceName(serviceName);
  
  // Check for exact match first
  if (SERVICE_LOGOS[normalizedName]) {
    return SERVICE_LOGOS[normalizedName];
  }
  
  // Check for partial matches (e.g., "netflix premium" matches "netflix")
  for (const [key, logo] of Object.entries(SERVICE_LOGOS)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return logo;
    }
  }
  
  // Fallback to category icon
  return getCategoryIcon(category);
};

// Check if service has a logo
export const hasServiceLogo = (serviceName: string): boolean => {
  const normalizedName = normalizeServiceName(serviceName);
  
  if (SERVICE_LOGOS[normalizedName]) {
    return true;
  }
  
  // Check for partial matches
  for (const key of Object.keys(SERVICE_LOGOS)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return true;
    }
  }
  
  return false;
};

// Get all available service names for autocomplete
export const getAvailableServices = (): string[] => {
  return Object.keys(SERVICE_LOGOS).map(name => 
    name.charAt(0).toUpperCase() + name.slice(1)
  );
};
